import Link from "next/link";
import { ToastData } from "stores/ui/types";
export const CustomToast = ({
  toastData
}: {
  toastData?: ToastData | null;
}) => {
  return toastData ? <aside className={`fixed bottom-[142px] z-[1000] flex w-[calc(100%-32px)] flex-col rounded-lg border-t-[12px] bg-white p-4 shadow-[0_4px_20px_0_rgba(55,56,77,0.13)] ssm2:bottom-[146px] msm:bottom-[216px] msm:left-0 msm:right-0 msm:mx-auto msm:w-[320px] msm:p-6 md:bottom-[unset] md:left-[unset] md:right-4 md:top-[62px] md:mx-0 md:shadow-[0_4px_20px_0_rgba(55,56,77,0.13)]
    ${toastData?.className} ${toastData?.type === "success" ? "border-t-accent-500" : "border-t-[#ff0000]"}`} data-sentry-component="CustomToast" data-sentry-source-file="CustomToast.tsx">
      {toastData?.title && <p className='mb-2 text-base font-bold leading-[100%] tracking-[-0.24px] text-[#033243]'>
          {toastData?.title}
        </p>}
      <span className='break-words text-sm font-medium leading-[150%] text-Gray-700'>
        {toastData?.message}
      </span>
      {toastData?.linkURL && <div className='mt-5'>
          <Link href={toastData?.linkURL} target='_blank' rel='noreferrer' className='text-sm font-bold leading-[150%] text-Gray-700 underline'>
            {toastData?.linkName}
          </Link>
        </div>}
      {toastData?.footerText && (toastData?.footerOnClick ? <button type='button' onClick={() => toastData?.footerOnClick?.()} className='mt-4 text-start text-sm font-bold leading-[150%] text-Gray-700 underline'>
            {toastData?.footerText}
          </button> : <span className='mt-5 text-sm font-medium leading-[150%] text-Gray-700'>
            {toastData?.footerText}
          </span>)}
    </aside> : null;
};